export default __webpack_public_path__ + "static/media/YAS0510.34I-27775_-17194_0.6fa44f40.jpg";